import { PricingBlock, PricingBlockEntry } from '@ukpostbox/frontend-framework';
import React from 'react';
import { SignUpGenericSectionInterface } from '../Types/SignUp/SignUpSection';
import { SignUpPlanType } from '../Types/SignUp/SignUpPlan';
import { SignUpPerkType } from '../Types/SignUp/SignUpPerk';
import SignUpSectionHeader from './SignUpSectionHeader';
import { SelectPlan } from './SelectPlanButton';

function SignUpGenericSection(props: SignUpGenericSectionInterface) {
	const HandleEditCallback = () => {
		if (props.onEditCallback) {
			props.onEditCallback();
		}
	};

	return (
		<div
			className={`sign-up-section ${props.visible ? 'mb-xxxl' : 'sign-up-section-hide'} ${props.complete && !props.visible ? 'sign-up-section-complete mt-xs' : 'mt-lg'}`}
		>
			<SignUpSectionHeader
				label={props.label}
				completeLabel={props.completeLabel}
				complete={props.complete}
				visible={props.visible}
				editCallBack={() => HandleEditCallback()}
			/>

			{props.visible && (
				<div className='flex-row flex-wrap flex-gap-sm plan-wrapper'>
					{props.plansOverview.map((plan: SignUpPlanType) => {
						if (!plan.enabled) return null;

						return (
							<PricingBlock
								key={`plan${plan.id}`}
								title={plan.label}
								price={plan.cost}
								extraInfo={plan.labelExtra}
								variablePrice={plan.variablePrice}
								callBackContent={<SelectPlan parentProps={props} itemProps={plan} />}
							>
								<div className='pricing-block-entries'>
									{props.planPerks.map((perk: SignUpPerkType) => {
										const included = plan.perks.includes(perk.id);

										if (!perk.enabled || (props.hideExcluded && !included)) return null;

										return (
											<PricingBlockEntry
												key={`${plan.id}-${perk.id}`}
												title={perk.label}
												markersFirst
												noMarkers={props.hideMarks}
												included={included}
												showTip={plan.tips && plan.tips.includes(perk.id)}
											/>
										);
									})}
								</div>
							</PricingBlock>
						);
					})}
				</div>
			)}
		</div>
	);
}

export default SignUpGenericSection;
